<template>
  <button type="button" class="theme-toggle" @click.stop="themeStore.toggleTheme">
    <img :src="themeStore.isDarkMode ? ASSETS.LIGHTBULB_REGULAR : ASSETS.LIGHTBULB_SOLID"
      class="lamp-icon" 
    />
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { themeStore } from "@/stores/themeStore";
import { ASSETS } from "@/constants";

@Options({})
export default class ThemeToggle extends Vue {
  themeStore = themeStore;
  ASSETS = ASSETS;
}
</script>

<style scoped>
.theme-toggle {
  cursor: pointer;
  display: flex;
  justify-content: center;
  background: var(--color-background-alt);
  color: var(--color-text-default);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  transition: background 0.3s ease, color 0.3s ease;
  width: 50px;
}

.lamp-icon {
  width: 24px;
  height: 24px;
  filter: var(--color-icon-filter);
}

.theme-toggle:hover {
  background: var(--color-text-hover);
  color: var(--color-background);
}
</style>
